var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpensesAndRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_66101c6e5dbe0b445b5b00515cd8dae9c96be6dc34fd800b94253a2460008b61",
    x1: 137.47,
    y1: 47.56,
    x2: 165.68,
    y2: 47.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M52.28 138.68h93.87M67.82 73.71h31.39v55.73H67.82z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_66101c6e5dbe0b445b5b00515cd8dae9c96be6dc34fd800b94253a2460008b61)",
    d: "M146.3 63.47H157V44.43h7.43l-13.4-12.78-12.31 13.09h7.58v18.73z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M52.12 83.95H41.43v19.04H34l13.4 12.78 12.31-13.09h-7.59V83.95z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_66101c6e5dbe0b445b5b00515cd8dae9c96be6dc34fd800b94253a2460008b61)",
    d: "M121.29 129.44l9.31-9.31M103.19 129.44l27.41-27.41M99.21 115.31l31.39-31.39M99.26 97.16l30.73-30.73M99.23 79.08l31.37-31.37M99.23 62.44l26.55-26.55M99.23 45.8l10.19-10.18M99.21 35.53h31.39v93.91H99.21z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M34.66 73.71h5M44.64 73.71h5M54.63 73.71h5M139.09 73.71h5M149.07 73.71h5M159.06 73.71h5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpensesAndRevenue);
export default __webpack_public_path__ + "static/media/expensesAndRevenue.26222694c4578f558a1aac9c289ed664.svg";
export { ForwardRef as ReactComponent };